import { render, staticRenderFns } from "./ViewPdf.vue?vue&type=template&id=038aa383&scoped=true"
import script from "./ViewPdf.vue?vue&type=script&lang=js"
export * from "./ViewPdf.vue?vue&type=script&lang=js"
import style0 from "./ViewPdf.vue?vue&type=style&index=0&id=038aa383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038aa383",
  null
  
)

export default component.exports